import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

export const menuSectionsTwo = [
  {
    title: "Home",
    icon: HomeIcon,
    items: [
      {
        text: "Dashboard",
        path: "/dashboard/dashbordhome",
        role: "3_13",
      },
    ],
  },
  {
    title: "Master",
    icon: BusinessIcon,
    items: [
      {
        text: "Company Master",
        path: "/dashboard/CompanyMaster",
        role: "2_1",
      },
      {
        text: "Plant Master",
        path: "/dashboard/PlantMaster",
        role: "2_2",
      },
      {
        text: "Location Master",
        path: "/dashboard/LocationMaster",
        role: "2_3",
      },
      {
        text: "Sub Loacation Master",
        path: "/dashboard/SubLocationMaster",
        role: "2_4",
      },
      {
        text: "Department Master",
        path: "/dashboard/DepartmentMaster",
        role: "2_5",
      },
      {
        text: "Asset Category Code",
        path: "/dashboard/CategoryMaster",
        role: "2_6",
      },
      {
        text: "Asset Master",
        path: "/dashboard/AssetMaster",
        role: "2_7",
      },
      {
        text: "Supplier Master",
        path: "/dashboard/CustomerMaster",
        role: "2_8",
      },
      {
        text: "Employee Master",
        path: "/dashboard/EmployeeMaster",
        role: "2_9",
      },
      {
        text: "Email Master",
        path: "/dashboard/EmailMaster",
        role: "2_10",
      },
    ],
  },
  {
    title: "Transction",
    icon: ReceiptIcon,
    items: [
      {
        text: "Print Asset Barcode",
        path: "/dashboard/PrintAssetBarcode",
        role: "3_1",
      },
      {
        text: "Reprint Asset Barcode",
        path: "/dashboard/ReprintAssetBarcode",
        role: "3_2",
      },
      {
        text: "Generated Barcode",
        path: "/dashboard/GenrateBarcodeAsset",
        role: "3_3",
      },
    ],
  },
  {
    title: "Admin Reports",
    icon: AssessmentIcon,
    items: [
      {
        text: "Rep-Generate Barcode",
        path: "/dashboard/ReportAssetGenerateBarcode",
        role: "4_1",
      },
      {
        text: "Rep-Asset Identification",
        path: "/dashboard/ReportAssetIdentification",
        role: "4_2",
      },
      {
        text: "Rep-Available Asset",
        path: "/dashboard/ReportAvailableAsset",
        role: "4_3",
      },
      {
        text: "Rep-Asset Assign",
        path: "/dashboard/ReportAssetAssign",
        role: "4_4",
      },
      {
        text: "Rep-Asset De-Assign",
        path: "/dashboard/ReportAssetDeAssign",
        role: "4_5",
      },
      {
        text: "Rep-Asset Issued",
        path: "/dashboard/ReportAssetIssued",
        role: "4_6",
      },
      {
        text: "Rep-Pending For Receipt",
        path: "/dashboard/ReportAssetPendingFRec",
        role: "4_7",
      },
      {
        text: "Rep-Asset Receipt",
        path: "/dashboard/ReportAssetReceipt",
        role: "4_8",
      },
      {
        text: "Rep-In Transit Diversion",
        path: "/dashboard/ReportAssetInTransitDiversion",
        role: "4_9",
      },
      {
        text: "Rep-Asset Depreciation",
        path: "/dashboard/ReportAssetDepreciation",
        role: "4_10",
      },
      {
        text: "Rep-Physical Stock Take",
        path: "/dashboard/RepAssetPhStockTake",
        role: "4_11",
      },
      {
        text: "Rep-Asset OverAll",
        path: "/dashboard/ReportAssetOverAllReport",
        role: "4_12",
      },
      {
        text: "Rep-Cost Depreciation",
        path: "/dashboard/ReportCostDepreciation",
        role: "4_13",
      },
    ],
  },
  {
    title: "Administrator",
    icon: AdminPanelSettingsIcon,
    items: [
      {
        text: "User Master",
        path: "/dashboard/UserMaster",
        role: "10_1",
      },
      {
        text: "User Role Master",
        path: "/dashboard/UserRoleMaster",
        role: "10_2",
      },
      {
        text: "Change Password",
        path: "/dashboard/UserChangePassword",
        role: "10_3",
      },
      {
        text: "Android App Access",
        path: "/dashboard/androidappaccess",
        role: "10_4",
      },
    ],
  },
];
